import React, { FC, Fragment } from 'react';
import { ContactType, ControlledInput, ControlledSelect, Section } from '../../../shared';
import { Button, IconButton, MenuItem, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { useFieldArray, useFormContext } from 'react-hook-form';

export const OrganisationContactInputs: FC = () => {
    const { t } = useTranslation();
    const { control } = useFormContext();

    const {
        fields: contacts,
        append,
        remove,
    } = useFieldArray({
        control,
        name: 'contacts',
    });

    return (
        <Section title={t('contactInformation')}>
            {contacts.map((contact, index) => (
                <Fragment key={contact.id}>
                    <Stack direction="row" spacing={2}>
                        <ControlledSelect name={`contacts.${index}.type`} label={t('typeLabel')}>
                            {Object.entries(ContactType).map(([key, value]) => (
                                <MenuItem value={value} key={value}>
                                    {t(key)}
                                </MenuItem>
                            ))}
                        </ControlledSelect>
                        <ControlledInput
                            name={`contacts.${index}.data`}
                            label={t('contactLabel')}
                            required={true}
                            sx={{ width: '400px' }}
                        />
                        <IconButton aria-label="delete" onClick={() => remove(index)} size="large">
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                </Fragment>
            ))}
            <Button
                data-testid="add-contact"
                onClick={() => append({ type: ContactType.Email, data: '' })}
                color="secondary"
            >
                + {t('contactsAdd')}
            </Button>
        </Section>
    );
};
